@if (events.length > 0 || bookings.length > 0) {
<div class="events-card">
  <div class="section-label section-label--info">Aujourd'hui au SDIS</div>
  <div [class.events-banner--alone]="!showBookings" class="events-banner">
  <button (click)="toggle()" [attr.aria-expanded]="expanded" class="events-banner-summary events-banner-summary--events" type="button">
    <i class="fal fa-calendar-alt"></i>
    <span>
      @if (events.length) {
      <b>{{ events.length }}</b>
      événement{{ events.length > 1 ? 's' : '' }} aujourd'hui
      — {{ events[0].text }}
      ({{ events[0].startDateDate | date : 'HH:mm' }}–{{ events[0].endDateDate | date : 'HH:mm' }})
      @if (isOngoing(events[0].startDateDate, events[0].endDateDate)) {
      <span class="live-pill live-pill--summary"><span class="live-dot"></span>En cours</span>
      }
      } @else { Aucun événement aujourd'hui }
    </span>
    <i class="fal events-banner-chevron" [ngClass]="expanded ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
  </button>

  @if (expanded) {
  <div class="events-banner-col events-banner-col--events">
    <ul class="events-banner-list">
      @for (e of events; track e) {
      <li>
        <span class="events-banner-time">{{ e.startDateDate | date : 'HH:mm' }}–{{ e.endDateDate | date : 'HH:mm' }}</span>
        @if (isOngoing(e.startDateDate, e.endDateDate)) {
        <span class="live-pill"><span class="live-dot"></span>En cours</span>
        }
        @if (bookingsOf(e).length) {
        <a
          [attr.aria-label]="'Commande de matériel de ' + e.text"
          [routerLink]="['/booking/view', bookingsOf(e)[0].id]"
          class="events-banner-link text-capitalize"
        >
          <em
            [ngClass]="e.roulage ? 'fa-truck' : 'fa-box'"
            class="fal events-banner-link-icon"
          ></em>{{ e.text }}
        </a>
        @if (bookingsOf(e).length > 1) {
        <span class="events-banner-multi">{{ bookingsOf(e).length }} commandes</span>
        }
        } @else {
        <span class="text-capitalize">
          @if (e.roulage) {
          <em class="fal fa-truck events-banner-link-icon"></em>
          }{{ e.text }}
        </span>
        }
        @if (e.participants?.length) {
        <button
          (click)="showParticipants(e)"
          [attr.aria-label]="e.participants.length + ' convoqués — voir la liste'"
          class="chip-button"
          type="button"
        >
          <em class="fal fa-users"></em>{{ e.participants.length }}
        </button>
        }
      </li>
      } @empty {
      <li class="events-banner-none">Aucun événement aujourd'hui</li>
      }
    </ul>
    <a [queryParams]="{ ecawin: true }" [routerLink]="['/booking/calendar']" class="events-banner-viewall">Calendrier complet →</a>
  </div>
  }

  @if (showBookings) {
  <button (click)="toggle()" [attr.aria-expanded]="expanded" class="events-banner-summary events-banner-summary--bookings" type="button">
    <i class="fal fa-box"></i>
    <span>
      @if (bookings.length) {
      <b>{{ bookings.length }}</b>
      commande{{ bookings.length > 1 ? 's' : '' }} de matériel
      @if (vehiclesCount) {
      — <b>{{ vehiclesCount }}</b> véhicule{{ vehiclesCount > 1 ? 's' : '' }}
      } @else {
      — {{ resourcesCount }} ressource{{ resourcesCount > 1 ? 's' : '' }}
      }
      jusqu'à {{ lastEnd | date : 'HH:mm' }}
      } @else { Aucun matériel commandé aujourd'hui }
    </span>
  </button>

  @if (expanded) {
  <div class="events-banner-col events-banner-col--bookings">
    <ul class="events-banner-list">
      @for (b of bookings; track b.id) {
      <li>
        <span class="events-banner-time">{{ b.start | date : 'HH:mm' }}–{{ b.end | date : 'HH:mm' }}</span>
        @if (isOngoing(b.start, b.end)) {
        <span class="live-pill"><span class="live-dot"></span>En cours</span>
        }
        <a [routerLink]="['/booking/view', b.id]" class="events-banner-link">{{ b.eventName }}</a>
        @if (b.unlinked) {
        <em
          aria-label="Commande non rattachée"
          class="fal fa-exclamation-triangle booking-unlinked"
          container="body"
          tooltip="Cette commande n'est liée ni à un événement Ecawin ni à un roulage"
        ></em>
        }
        @if (b.pending) {
        <span class="badge rounded-pill bg-warning-subtle text-warning-emphasis">En attente</span>
        }
        <span class="events-banner-resources">
          @for (v of b.vehicles; track v) {
          <span class="res-chip res-chip--vehicle"><em class="fal fa-truck"></em> {{ v }}</span>
          }
          @if (isResourcesExpanded(b.id)) { @for (o of b.others; track o) {
          <span class="res-chip">{{ o }}</span>
          } }
          @if (b.apr) {
          <span class="res-chip">{{ b.apr }} APR</span>
          }
          @if (b.others.length) {
          <button (click)="toggleResources(b.id)" class="btn btn-light btn-sm rounded-pill res-more" type="button">
            {{ isResourcesExpanded(b.id) ? 'Réduire' : '+' + b.others.length }}
          </button>
          }
        </span>
      </li>
      } @empty {
      <li class="events-banner-none">Aucun matériel commandé aujourd'hui</li>
      }
    </ul>
    <a [routerLink]="['/booking/all']" class="events-banner-viewall">Toutes les commandes →</a>
  </div>
  }
  }
  </div>
</div>
}

<div #participantsModal="bs-modal" bsModal class="modal" role="dialog" tabindex="-1">
  @if (selectedEvent) {
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title text-capitalize">{{ selectedEvent.text }}</h4>
        <button
          (click)="participantsModal.hide()"
          aria-label="Fermer"
          class="btn-close"
          type="button"
        ></button>
      </div>

      <div class="modal-body">
        <p class="participants-meta">
          {{ selectedEvent.startDateDate | date : 'HH:mm' }}–{{ selectedEvent.endDateDate | date : 'HH:mm' }}
          @if (selectedEvent.location) {
          · {{ selectedEvent.location }}
          }
          · {{ selectedEvent.participants.length }} convoqué{{ selectedEvent.participants.length > 1 ? 's' : '' }}
        </p>

        <ul class="participants-list">
          @for (p of selectedEvent.participants; track p.nip) {
          <li [class.text-decoration-line-through]="p.absence">
            @if (p.rank) {<span class="participant-rank">{{ p.rank }}</span>}
            {{ p.firstname }} {{ p.lastname }}
            @if (p.absence) {
            <span class="badge rounded-pill bg-warning-subtle text-warning-emphasis">Excusé</span>
            }
          </li>
          }
        </ul>
      </div>

      <div class="modal-footer">
        <button (click)="participantsModal.hide()" class="btn btn-light" type="button">Fermer</button>
      </div>
    </div>
  </div>
  }
</div>
